module.exports = __webpack_public_path__ + "img/1150791864.4601eebf.jpg";